import { Box, Typography } from '@mui/material'
import { Image24Regular, Video24Regular, Mic24Regular } from '@/components/Icon'
import { fluentIconFontSizeSx } from '@/theme/sx/fluentIconWrapperSx.js'

const iconMap = { image: Image24Regular, video: Video24Regular, audio: Mic24Regular }

const MediaBlock = ({ type = 'image', url, alt, caption }) => {
  const Icon = iconMap[type] || Image24Regular;

  return (
    <Box sx={{ my: '8px', display: 'flex', flexDirection: 'column', gap: '4px' }}>
      <Box sx={{
        width: '100%',
        maxWidth: '400px',
        borderRadius: 'var(--app-radius-md)',
        overflow: 'hidden',
        border: 'none',
        backgroundColor: 'transparent',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '120px',
      }}>
        {url ? (
          type === 'image' ? (
            <Box component="img" src={url} alt={alt} sx={{ width: '100%', height: 'auto', display: 'block' }} />
          ) : type === 'video' ? (
            <Box component="video" src={url} controls sx={{ width: '100%', display: 'block' }} />
          ) : (
            <Box component="audio" src={url} controls sx={{ width: '90%', my: '16px' }} />
          )
        ) : (
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', color: 'text.disabled', py: '24px' }}>
            <Box component="span" sx={fluentIconFontSizeSx(32, { mb: '8px' })} aria-hidden>
              <Icon />
            </Box>
            <Typography variant="body2">Media not found</Typography>
          </Box>
        )}
      </Box>
      {caption && (
        <Typography variant="body2" sx={{ color: 'text.secondary', textAlign: 'center', maxWidth: '400px' }}>
          {caption}
        </Typography>
      )}
    </Box>
  )
}

export default MediaBlock
